import Button from '@mui/material/Button';
import { Download } from 'react-feather';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import { useContext } from 'react';
import { SBOMContext } from '../../../pages/NRSBOMTable/NRSBOMDataShare';
import SBOMButtonStyles from './SBOMButton.styles';

const useStyles = makeStyles(SBOMButtonStyles);
function SBOMButton() {
  const classes = useStyles();
  const { openDownloadSBOM, setOpenDownloadSBOM } = useContext(SBOMContext);
  const handleClick = event => {
    setOpenDownloadSBOM(true);
  };
  return (
    <div className={classes.sbomDownloader} id={'sbom-download-buttons'}>
      <Button
        id="basic-button"
        aria-controls="basic-menu"
        aria-haspopup="true"
        variant="outlined"
        color="secondary"
        classes={{ root: classes.downloadButton }}
        startIcon={<Download size={18} />}
        aria-expanded={openDownloadSBOM ? 'true' : undefined}
        onClick={handleClick}
      >
        <Typography variant="subtitle2" component="span">
          Download SBOM
        </Typography>
      </Button>
    </div>
  );
}

export default SBOMButton;
